// String as ID types are strings in graphql
export const INDUSTRY_MARKETING_ID = '58';
export const INDUSTRY_UNDEFINED_ID = '697';
